import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useWindows } from "@app/overlay";
import { OPEN_FILTER_QUERY_PARAM } from "@app/router/queryParams";
import { CardHeader } from "@shared/ui/card-header";
import { BusinessList } from "@src/components/business-list";
import { ListItem } from "@src/components/business-list";
import { BusinessDivisionValue, BusinessDateValue } from "@src/components/business-data-display";
import { useBusinessListQuery } from "@src/hooks/useBusinessListQuery";
import { useUrlFilter } from "@shared/hooks/useUrlFilter";
import { useUrlParamTrigger } from "@shared/hooks/useUrlParamTrigger";
import { wsInvActsServices, type WsInvAct, type WsInvActFilter } from "../../../../api/wsInvActs";
import { wsInvActsListWindows } from "./wsInvActsList.windows";
import "./WsInvActsList.scss";

export const WsInvActsList: FC = () => {
    const windows = useWindows();
    const navigate = useNavigate();
    const filterState = useUrlFilter<WsInvActFilter>();

    const list = useBusinessListQuery<WsInvAct, WsInvActFilter>({
        queryKey: "workshop.wsInvActs",
        filter: filterState.filter,
        queryFn: async (flt, signal) => {
            const result = await wsInvActsServices.load({ flt, include: ["Division", "DivisionSection"] }, { signal });
            return result.items;
        },
        getId: (item) => item.Code,
    });

    const openFilterWindow = (): void => {
        wsInvActsListWindows.filter.open(windows, {
            initialFilter: filterState.filter,
            onApply: (flt) => {
                filterState.applyFilter(flt, true);
            },
        });
    };

    useUrlParamTrigger(OPEN_FILTER_QUERY_PARAM, () => {
        openFilterWindow();
    });

    return (
        <div className="ws_inv_rep_list_page">
            <CardHeader
                text={"Акты инвентаризации УП"}
                buttons={[
                    {
                        type: "button",
                        text: "Поиск",
                        srcIcon: "/images/common/options.svg",
                        onClick: openFilterWindow,
                    },
                ]}
            />
            <BusinessList list={list} onOpenFilter={openFilterWindow}>
                {list.data.map((item) => (
                    <ListItem
                        key={item.Code}
                        title={`Акт инвентаризации №${item.CommandNum}`}
                        props={[
                            {
                                label: "Подразделение",
                                value: <BusinessDivisionValue division={item.Division} section={item.DivisionSection} />,
                            },
                            { label: "Дата приказа", value: <BusinessDateValue value={item.CommandDate} /> },
                        ]}
                        onClick={() => {
                            navigate({ pathname: `${item.Code}` });
                        }}
                    />
                ))}
            </BusinessList>
        </div>
    );
};
